import { render, staticRenderFns } from "./Dealerstock.vue?vue&type=template&id=005dc253&"
import script from "./Dealerstock.vue?vue&type=script&lang=js&"
export * from "./Dealerstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports